var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44224 0.814548C1.18189 0.554198 0.75978 0.554198 0.49943 0.814548C0.239081 1.0749 0.239082 1.49701 0.499431 1.75736L4.74207 6L0.499432 10.2426C0.239082 10.503 0.239081 10.9251 0.499431 11.1854C0.75978 11.4458 1.18189 11.4458 1.44224 11.1854L5.68488 6.94281L9.92752 11.1854C10.1879 11.4458 10.61 11.4458 10.8703 11.1854C11.1307 10.9251 11.1307 10.503 10.8703 10.2426L6.62769 6L10.8703 1.75736C11.1307 1.49701 11.1307 1.0749 10.8703 0.814548C10.61 0.554198 10.1879 0.554198 9.92752 0.814548L5.68488 5.05719L1.44224 0.814548Z",
    fill: "#151515",
    className: "hc-mode-search"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCloseIcon);
export default __webpack_public_path__ + "static/media/search-close-icon.9c600cea990a13bfb04aa4358b47df19.svg";
export { ForwardRef as ReactComponent };